import { useQuery } from "@tanstack/react-query";
import { Alert, Button } from "../../../../../shared/frontend/ui";
import { useAuth } from "../app/auth/useAuth";
import { useI18n } from "../app/i18n/useI18n";
import { globalKey } from "../app/query/queryKeys";
import { DocumentPdfPreviewModal } from "./DocumentPdfPreviewModal";
import { ThemedModal } from "./ThemedModal";

/** Zeigt ausschließlich das bereits archivierte Schreiben der angelegten Mahnung. */
export function ReminderPrintPreview({ reminderId, personId, onClose }: {
  reminderId: string;
  personId: string;
  onClose: () => void;
}) {
  const { api } = useAuth();
  const { text } = useI18n();
  const previewQuery = useQuery({
    queryKey: globalKey("reminders", "print-document", { reminderId, personId }),
    queryFn: async () => {
      const detail = await api.get<{ attachedDocumentId?: string | null }>(`/api/v1/reminders/${encodeURIComponent(reminderId)}`);
      if (!detail.attachedDocumentId) return null;
      const blob = await api.blob(`/api/v1/persons/${encodeURIComponent(personId)}/documents/${encodeURIComponent(detail.attachedDocumentId)}?inline=true`);
      return new Uint8Array(await blob.arrayBuffer());
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  if (previewQuery.data) return <DocumentPdfPreviewModal open title={text("Print preview")}
    fileName={`${text("Reminder")}.pdf`} fileData={previewQuery.data} onCancel={onClose} />;

  // Laden und fehlende Dokumente bleiben im Modal; die fertige Datei nutzt dieselbe
  // PDF-Vorschau wie Kündigungs- und Ruhezeitschreiben.
  return <ThemedModal open title={text("Print preview")} footer={null} onCancel={onClose}
    contentLoading={previewQuery.isLoading} autoFocusFirstField={false}>
    {previewQuery.isPending ? <span>{text("Loading…")}</span> : <>
      <Alert type="warning" showIcon title={text(previewQuery.isError
        ? "PDF preview could not be loaded." : "Reminder letter document not found")} />
      <Button onClick={() => previewQuery.refetch()}>{text("Retry")}</Button>
    </>}
  </ThemedModal>;
}
